// https://javascript.plainenglish.io/building-a-robust-license-plate-detection-and-recognition-system-using-javascript-8c64b314eec2

import { Injectable } from '@angular/core';
import type opencv from '@techstark/opencv-js';

declare var cv: opencv.CV;

@Injectable({
  providedIn: 'root',
})
export class LicensePlateRecognition {
  processImage(canvas: HTMLElement) {
    const startTime = Date.now();

    // Load the image
    let src = cv.imread(canvas);

    // Convert the image to grayscale
    const gray = new cv.Mat();
    cv.cvtColor(src, gray, cv.COLOR_RGBA2GRAY);

    // remove noice
    cv.medianBlur(gray, gray, 3);

    const gray2 = new cv.Mat();
    // Increase contrast
    cv.convertScaleAbs(gray, gray2, 1.2, 0);

    const tempCanvasDeblurGrayscale = document.createElement('canvas');
    cv.imshow(tempCanvasDeblurGrayscale, gray2);
    const base64ImageForTesseractGrayscale = tempCanvasDeblurGrayscale.toDataURL();

    // Otsu's thresholding
    cv.threshold(gray, gray, 0, 255, cv.THRESH_BINARY + cv.THRESH_OTSU);

    // Dilation can connect broken characters; erosion can remove small dots
    let kernel = cv.getStructuringElement(cv.MORPH_RECT, new cv.Size(3, 3));
    cv.dilate(gray, gray, kernel);

    // Convert the image to black and white
    let binary = new cv.Mat();
    cv.adaptiveThreshold(gray, binary, 255, cv.ADAPTIVE_THRESH_GAUSSIAN_C, cv.THRESH_BINARY, 11, 2);

    // Apply edge detection
    const edges = new cv.Mat();
    cv.Canny(gray, edges, 50, 200);

    // Find contours
    const contours = new cv.MatVector();
    const hierarchy = new cv.Mat();
    cv.findContours(edges, contours, hierarchy, cv.RETR_LIST, cv.CHAIN_APPROX_SIMPLE);

    let licensePlate;

    const tempCanvas = document.createElement('canvas');
    const ctx = tempCanvas.getContext('2d');
    cv.imshow(tempCanvas, binary);
    let foundPlates = 0;

    const base64ImageForTesseract = tempCanvas.toDataURL();

    // Iterate through the contours
    for (let i = 0; i < contours.size(); i++) {
      const contour = contours.get(i);
      const rect = cv.boundingRect(contour);

      const aspectRatio = rect.width / rect.height;
      if (aspectRatio > 2 && aspectRatio < 5) {
        //checking aspect ratio to locate license plate
        licensePlate = rect;

        // Draw the rectangle around the detected license plate on tempCanvas
        ctx.strokeStyle = 'blue';
        ctx.lineWidth = 4;
        ctx.strokeRect(licensePlate.x, licensePlate.y, licensePlate.width, licensePlate.height);
        foundPlates++;
      }
    }

    const base64Image = tempCanvas.toDataURL();

    const timeSeconds = Math.round(Date.now() - startTime) / 1000;

    return {
      licensePlate,
      base64ImageForTesseract,
      base64Image,
      time: timeSeconds,
      base64ImageForTesseractGrayscale,
      foundPlates,
    };
  }
}
